import { SvgIconComponent } from '@mui/icons-material'
import WarningIcon from '@mui/icons-material/Warning'
import { AppBar, Container, IconButton, Toolbar, Typography, useTheme } from '@mui/material'
import { ReactElement } from 'react'

interface AlertBannerProps {
  message: string
  variant?: 'error' | 'info' | 'warning' | 'success'
  show?: boolean
  icon?: ReactElement<SvgIconComponent>
}

const AlertBanner = ({ message, variant = 'error', show = true, icon = <WarningIcon /> }: AlertBannerProps) => {
  const theme = useTheme()

  const barColor = variant === 'error' ? theme.palette.error.main : theme.palette.info.main

  return (
    <AppBar
      position="sticky"
      sx={[
        {
          backgroundColor: barColor,
          top: 0,
          zIndex: 1500,
        },
        show
          ? {
              display: 'flex',
            }
          : {
              display: 'none',
            },
      ]}
    >
      <Container maxWidth="xl" disableGutters>
        <Toolbar variant="dense" style={{ justifyContent: 'center', display: 'flex' }}>
          <IconButton color="inherit" aria-label="menu" sx={{ marginRight: 1 }}>
            {icon}
          </IconButton>
          <Typography variant="h5" color="inherit">
            {message}
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default AlertBanner
